(() => {
  const flag = window.ph_feature_flag_key;
  if (!['calm-001-case-studies-above-fold', 'itch-001-case-studies-above-fold'].includes(flag)) return;
  const instance = flag === 'itch-001-case-studies-above-fold' ? 'pcdItchStories' : 'pcdCalmStories';
  if (window[instance]) return;

  const roots = new Set();
  const visibleMarkers = new Set();
  let cohort;
  let fallback = Boolean(window.pcdAnalytics?.fallback);
  let exposureCaptured = false;

  function captureExposure() {
    if (exposureCaptured || !cohort || !window.posthog) return;
    if (![...visibleMarkers].some(marker => marker.isConnected &&
      marker.dataset.calmStoriesExposure === cohort)) return;
    exposureCaptured = true;
    window.posthog.capture('experiment_exposure', {
      [`$feature/${flag}`]: cohort,
      experiment: flag,
      variant: cohort,
      treatment: 'customer-stories-v1',
      placement: 'main-product'
    });
  }

  function applyCohort() {
    roots.forEach(root => {
      const active = cohort === 'test';
      root.toggleAttribute('data-calm-stories-active', active);
      root.querySelectorAll('[data-calm-stories-control-summary]').forEach(item => {
        item.hidden = cohort !== 'control' && !(!cohort && fallback);
        if (cohort || fallback) item.classList.remove('a-b-test-hidden-on-load');
      });
      root.querySelectorAll('[data-calm-stories-treatment]').forEach(item => { item.hidden = !active; });
    });
    if (observer) captureExposure();
    else checkVisibility();
  }

  function readFlag() {
    const value = window.posthog?.getFeatureFlag(flag);
    cohort = value === 'test' ? 'test' : value === 'control' ? 'control' : undefined;
    applyCohort();
  }

  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) visibleMarkers.add(entry.target);
      else visibleMarkers.delete(entry.target);
    });
    captureExposure();
  }, { threshold: 0 }) : null;

  function checkVisibility() {
    roots.forEach(root => {
      root.querySelectorAll('[data-calm-stories-exposure]').forEach(marker => {
        const rect = marker.getBoundingClientRect();
        if (rect.bottom > 0 && rect.top < window.innerHeight) visibleMarkers.add(marker);
        else visibleMarkers.delete(marker);
      });
    });
    captureExposure();
  }

  function selectStory(root, button, reveal) {
    if (button.getAttribute('aria-pressed') === 'true') return;
    const panelId = button.getAttribute('aria-controls');
    const panels = [...root.querySelectorAll('[data-calm-story-panel]')];
    const panel = panels.find(item => item.id === panelId);
    if (!panel) return;
    root.querySelectorAll('[data-calm-story-choice]').forEach(choice => {
      choice.setAttribute('aria-pressed', String(choice === button));
    });
    panels.forEach(item => { item.hidden = item !== panel; });
    if (reveal && panel.getBoundingClientRect().top < 0) {
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      panel.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
    }
  }

  function scan() {
    document.querySelectorAll('[data-calm-story-test]').forEach(root => {
      if ((root.dataset?.customerStoriesFlag || 'calm-001-case-studies-above-fold') !== flag || roots.has(root)) return;
      roots.add(root);
      root.querySelectorAll('[data-calm-stories-exposure]').forEach(marker => observer?.observe(marker));
      root.addEventListener('click', event => {
        const button = event.target.closest('[data-calm-story-choice]');
        if (button && root.contains(button)) selectStory(root, button, true);
      });
      root.addEventListener('keydown', event => {
        const button = event.target.closest('[data-calm-story-choice]');
        if (!button || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        const choices = [...root.querySelectorAll('[data-calm-story-choice]')];
        const offset = event.key === 'ArrowRight' ? 1 : -1;
        const index = event.key === 'Home' ? 0 : event.key === 'End' ? choices.length - 1 :
          (choices.indexOf(button) + offset + choices.length) % choices.length;
        event.preventDefault();
        choices[index].focus();
        selectStory(root, choices[index], false);
      });
    });
    applyCohort();
  }

  window[instance] = { refresh: scan };
  scan();
  if (window.pcdAnalytics) window.pcdAnalytics.onFeatureFlags(readFlag);
  else window.posthog?.onFeatureFlags(readFlag);
  document.addEventListener('pcd:analytics-fallback', () => {
    fallback = true;
    applyCohort();
  });
  readFlag();
  document.addEventListener('shopify:section:load', scan);
  if (!observer) {
    window.addEventListener('scroll', checkVisibility, { passive: true });
    window.addEventListener('resize', checkVisibility);
  }
})();
